const LEH_LADAKH_FAQ = [
  {
    question: 'What is the best time to visit Ladakh?',
    answer:
      'The best time to visit Ladakh is from May to September, when the roads are open, the weather is pleasant, and most attractions are accessible.'
  },
  {
    question: 'Do I need a visa to visit Ladakh?',
    answer:
      'Ladakh is part of India, so international travellers require a valid Indian visa. Visa requirements vary by nationality, and we can guide you with the latest information.'
  },
  {
    question: 'Is Ladakh suitable for first-time visitors to India?',
    answer:
      "Yes. Ladakh offers a unique side of India with spectacular Himalayan landscapes, Buddhist monasteries, and peaceful mountain villages. It's an excellent destination for travellers seeking nature, culture, and adventure."
  },
  {
    question: 'How many days should I spend in Ladakh?',
    answer:
      "We recommend 6–8 days to allow time for acclimatization while comfortably exploring the region's highlights, including Pangong Lake, Nubra Valley, and Leh."
  },
  {
    question: 'Will I experience altitude sickness?',
    answer:
      'Ladakh is a high-altitude destination, with Leh situated at approximately 3,500 metres (11,500 feet) above sea level. Spending the first 24–48 hours acclimatizing, staying hydrated, and avoiding strenuous activity helps most travellers adjust comfortably.'
  },
  {
    question: 'Are your tours suitable for families and senior travellers?',
    answer:
      'Yes. We offer thoughtfully planned itineraries with comfortable accommodation, experienced local support, and a pace that can be adapted to suit families, couples, and senior travellers.'
  },
  {
    question: 'What type of accommodation is included?',
    answer:
      "Our tours feature carefully selected hotels and boutique stays that offer comfort, warm hospitality, and convenient access to Ladakh's key attractions."
  },
  {
    question: 'Is it safe to travel in Ladakh?',
    answer:
      "Ladakh is considered one of India's safest travel destinations. Our experienced team carefully plans every journey, monitors local conditions, and provides assistance throughout your trip."
  },
  {
    question: 'Can this itinerary be customised?',
    answer:
      "Absolutely. Whether you're looking for a private journey, a photography expedition, an adventure holiday, or a luxury escape, our travel specialists can tailor the itinerary to your interests and travel style."
  },
  {
    question: 'Why travel with Kesari Tours?',
    answer:
      'With 42 years of experience in crafting exceptional journeys, Kesari Tours combines local expertise, carefully curated itineraries, quality accommodation, and dedicated support to ensure a seamless travel experience from arrival to departure.'
  }
];

export const DESTINATION_FAQ = {
  'leh-ladakh': LEH_LADAKH_FAQ,
  ladakh: LEH_LADAKH_FAQ,
  'leh-and-ladakh': LEH_LADAKH_FAQ,
  leh: LEH_LADAKH_FAQ
};

export const getDestinationFaq = () => LEH_LADAKH_FAQ;
